export const plans1 = [
	{
		title: 'PLAN STANDARD',
		descrition: 'El flujo de producción completo.',
		price: '$946 USD',
		priceBefore: '$1.229 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_J6BCPLEEZF',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTI5OSZpZD1MaWJlbCBIVUIgUGxhbiBDb3JlIC0gQWNjZXNvIDEgYfFv',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Entrenamientos Plan Standard.',
			},
			{
				title: '6 meses de feedback en vivo.',
			},
			{
				title: 'Acceso por 1 año.',
			},
			{
				title: 'Acceso a Discord privado.',
			},
		],
		center: true,
		top: false,
		ball: true,
		promo: '30% DTO',
		type: 'presencial',
	},
	{
		title: 'PLAN GROW',
		descrition: 'El flujo de producción completo.',
		price: '$1.299 USD',
		priceBefore: '$1.581 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_9ZV2JEN88Y',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTM5OSZpZD1MaWJlbCBIVUIgUGxhbiBGb3JnZSAtIEFjY2VzbyAxIGHxbw==',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Plan standard + extras exclusivos.',
			},
			{
				title: '8 meses de feedback en vivo.',
			},
			{
				title: 'Acceso por 1 año + 2 meses.',
			},
			{
				title: 'Acceso a Discord privado.',
			},
		],
		center: true,
		top: true,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
